import { useCallback, useMemo } from 'react';
import { RenderIf } from 'react-rainbow-components';
import Button from 'components/Button';
import ButtonIcon from 'components/ButtonIcon';
import Close from 'components/icons/close';
import Gradient from 'components/Gradient';
import useSearchFilters from 'hooks/useSearchFilters';
import EventIcon from 'components/icons/event';
import { events as eventsList } from '../../EventsSelectInput/constants';
import Accordion from '../../../Opportunities/View/accordion';
import {
    FilterHeader,
    Title,
    FiltersContainer,
    FiltersContent,
} from '../../../Opportunities/View/styled';
import { StyledWebhookEventsFilter } from './styled';

interface Params {
    onRequestClose?: () => void;
}

const filterNames = ['events'];

const Filters = ({
    onRequestClose = () => {},
}: Params) => {
    const {
        values,
        getValue: getFilterValue,
        setValue: setFilterValue,
        clear: clearFilters,
    } = useSearchFilters({ filterNames });

    const activeFiltersCount = useMemo(
        () => filterNames.reduce(
            (count, key) => (
                getFilterValue(key) !== null
                    ? count + 1
                    : count
            ),
            0,
        ),
        [getFilterValue],
    );

    const handleChangeTags = useCallback(
        (newFilterValue: string[] | null) => setFilterValue(
            'events',
            (
                newFilterValue === null
                    ? null
                    : newFilterValue.join(',')
            ),
        ),
        [setFilterValue],
    );

    const eventsFilterValue = useMemo(
        () => {
            const { events } = values;
            if (events !== null) return String(events).split(',');
            return null;
        },
        [values],
    );
    return (
        <FiltersContainer>
            <FilterHeader>
                <Title>
                    Filters
                    {' '}
                    <RenderIf isTrue={activeFiltersCount > 0}>
                        (
                        {activeFiltersCount}
                        )
                    </RenderIf>
                </Title>
                <div>
                    <Button
                        label="Clear"
                        variant="base"
                        size="small"
                        disabled={!activeFiltersCount}
                        borderRadius="semi-square"
                        onClick={clearFilters}
                    />
                    <ButtonIcon
                        borderRadius="semi-square"
                        size="small"
                        icon={<Close />}
                        onClick={onRequestClose}
                    />
                </div>
            </FilterHeader>
            <FiltersContent>
                <Accordion icon={<EventIcon />} label="Event Types" name="events">
                    <StyledWebhookEventsFilter
                        events={eventsList}
                        value={eventsFilterValue}
                        onChange={handleChangeTags}
                    />
                </Accordion>
            </FiltersContent>
            <Gradient position="bottom" />
        </FiltersContainer>
    );
};

export default Filters;
